module.exports = __webpack_public_path__ + "img/druzstevne_byvanie.5aa95af3.svg";